import { useMemo } from "react";

// Redux
import { useDispatch, useSelector } from "react-redux";
import { translateMessage } from "@delibrandev/utils";

import { removeOptionFromProduct, removeGroupFromProduct } from "../../../../../../api/options";

import { getProduct } from "../../../../../../api/products";
import { setAlert, updateFloatPanelData } from "../../../../../../reducers/userConfigSlice";

export const Options = () => {
  const dispatch = useDispatch();
  const idProduct = useSelector((state) => state.aplicationConfig.userConfig.floatPanel.queryId);
  const optionsProduct = useSelector((state) => state.aplicationConfig.userConfig.floatPanel.data.options);

  const alertFromResponse = (response) => {
    dispatch(setAlert(translateMessage(response?.message || "Bad request")));
  };

  const refreshActiveOptions = async () => {
    const response = await getProduct(idProduct);
    if (response && !response.error) {
      dispatch(updateFloatPanelData({ data: response.data.options, name: "options" }));
      dispatch(updateFloatPanelData({ data: response.data.variants, name: "variants" }));
      return true;
    }
    alertFromResponse(response);
    return false;
  };

  const groupedOptions = useMemo(() => {
    const grouped = (optionsProduct || []).reduce((acc, option) => {
      const groupId = option.optionGroupId;
      if (!acc[groupId]) {
        acc[groupId] = {
          optionGroupId: groupId,
          optionGroup: option.optionGroup,
          options: [],
        };
      }
      acc[groupId].options.push(option);
      return acc;
    }, {});

    return Object.values(grouped);
  }, [optionsProduct]);

  const handleDeleteGroup = async (itemGroupId) => {
    if (!itemGroupId) return;
    const response = await removeGroupFromProduct(idProduct, itemGroupId);
    if (response && !response.error) {
      alertFromResponse(response);
      await refreshActiveOptions();
      return;
    }
    alertFromResponse(response);
  };

  const handleRemoveItem = async (itemGroupId, itemId, e) => {
    // Evita disparar el click del contenedor del grupo (borrar grupo)
    if (e?.stopPropagation) e.stopPropagation();
    if (!itemGroupId || !itemId) return;

    const response = await removeOptionFromProduct(idProduct, itemId);
    if (response && !response.error) {
      alertFromResponse(response);
      await refreshActiveOptions();
      return;
    }
    alertFromResponse(response);
  };

  return (
    <>
      <div className="flex-gap">
        <div className="inputName mb-1">
          <div>
            <b>Opciones activas</b> (se usan en las variaciones)
          </div>
          <div> Si haces click en el grupo o en la opción podrás eliminarla si no está siendo usada en las variaciones.</div>
        </div>
      </div>

      <div className="groups-products">
        {optionsProduct &&
          groupedOptions.map((group, index) => {
            if (group.options.length === 0) return null;

            return (
              <div
                key={"options-organitation-area-" + index}
                className={"options-organitation-area"}
                role="button"
                tabIndex={0}
                onClick={() => handleDeleteGroup(group.optionGroupId)}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") handleDeleteGroup(group.optionGroupId);
                }}
                title="Click para eliminar el grupo activo del producto"
              >
                <div className={`options-organitation-title`}>
                  <b>{group.optionGroup.name?.charAt(0).toUpperCase() + group.optionGroup.name?.slice(1)}</b>
                </div>

                <div className="options-organitation-area-items">
                  {group.options &&
                    group.options.length > 0 &&
                    group.options.map((opt) => (
                      <div
                        className="options-organitation-area-item"
                        key={"options-organitation-area-item-" + opt.optionId}
                        role="button"
                        tabIndex={0}
                        onClick={(e) => handleRemoveItem(group.optionGroupId, opt.optionId, e)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter" || e.key === " ") handleRemoveItem(group.optionGroupId, opt.optionId, e);
                        }}
                        title="Click para eliminar esta opción del grupo activo"
                      >
                        {opt.name?.charAt(0).toUpperCase() + opt.name?.slice(1)}
                      </div>
                    ))}
                </div>
              </div>
            );
          })}
      </div>
    </>
  );
};
